import React from 'react';
import { ColumnComponentProps } from 'v2/utils/searchViewUtils';
import commentDotsIcon from 'v2/icons/commentDots.svg';
import Count from 'v2/common/Count/Count';

const Conversations = ({
  search,
  options: { conversationCount = {} },
}: ColumnComponentProps) => {
  return (
    <div className="position-relative">
      <img src={commentDotsIcon} alt="commentDotsIcon"></img>

      <Count
        id="conversation_counter"
        className={'count-component'}
        value={conversationCount[search.id]}
      />
    </div>
  );
};

export default Conversations;
